export const namespace = 'market';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
}

export const ActionType = {
  LOAD_MARKETS: `${namespace}/LOAD_MARKETS`,
  SET_MARKETS: `${namespace}/SET_MARKETS`,
  SET_LOAD_STATUS: `${namespace}/SET_LOAD_STATUS`,
  SET_DEFAULT_MARKETS: `${namespace}/SET_DEFAULT_MARKETS`
}

export const loadMarkets = () => ({
  type: ActionType.LOAD_MARKETS
})

export const setMarkets = (markets) => ({
  payload: {
    markets
  },
  type: ActionType.SET_MARKETS
})

export const setLoadStatus = (status) => ({
  payload: {
    status
  },
  type: ActionType.SET_LOAD_STATUS
})

export const setDefaultMarkets = (marketType) => ({
  payload: {
    marketType
  },
  type: ActionType.SET_DEFAULT_MARKETS
})
